export default __webpack_public_path__ + "static/Banner-GiftCards-2-bb890845a44965901cfb99a74e7ced84.jpg";